// Module
var code = `<button ng-if="\$ctrl.csv_data" ng-click="\$ctrl.download_chart_csv(\$ctrl.name)">CSV</button>
<button ng-if="\$ctrl.sql_query" ng-click="\$ctrl.open_sql_modal()">SQL</button>

<nvd3
    ng-if="\$ctrl.display"
    options="\$ctrl.options"
    data="\$ctrl.data"
    api="\$ctrl.nvd3_chart"
    config="{deepWatchData: false}"
></nvd3>
${"<" + "script"} type="text/ng-template" id="sql_modal.html">
    <div class="modal-header" style="text-align: right">
        <button class="btn btn-success" ng-click="\$ctrl.copy_sql_query()">Copy</button>
        <button class="btn btn-primary" ng-click="\$ctrl.close()">Close</button>
    </div>
    <div class="modal-body">
        <p style="white-space: pre-wrap">{{ \$ctrl.sql_query }}</p>
    </div>
${"<" + "/script"}>
`;
// Exports
module.exports = code;